import { render, staticRenderFns } from "./nearly-expired-and-re-order-product.vue?vue&type=template&id=6d8d0e8c&scoped=true&"
import script from "./nearly-expired-and-re-order-product.vue?vue&type=script&lang=js&"
export * from "./nearly-expired-and-re-order-product.vue?vue&type=script&lang=js&"
import style0 from "./nearly-expired-and-re-order-product.vue?vue&type=style&index=0&id=6d8d0e8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8d0e8c",
  null
  
)

export default component.exports